import React, { useEffect, useState, Component } from "react";
import "./App.css";
import List from "./List";
import Loader from "react-loader-spinner";
import Select from "react-select";

function App() {
  const [data, setData] = useState({});
  const [components, setComponents] = useState([]);
  const [status, setStatus] = useState({});
  const [loader, setLoader] = useState(true);

  const styles = {
    statuscode: {
      backgroundColor: "red",
      color: "#fff",
    },
    loader: {
      padding: 20,
    },
    control: (base) => ({
      ...base,
      minHeight: 28,
      background: "#f2f2f2",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
    clearIndicator: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),
  };

  switch (status.description) {
    case "All Systems Operational":
      styles.statuscode.backgroundColor = "#33a851";
      break;
    case "Major System Outage":
      styles.statuscode.backgroundColor = "#FF033E";
      break;
    case "Partial System Outage":
      styles.statuscode.backgroundColor = "#FF9900";
      styles.statuscode.color = "#253858";
      break;
    case "Minor Service Outage":
      styles.statuscode.backgroundColor = "#fbae40";
      styles.statuscode.color = "#253858";
      break;
    case "Degraded System Service":
      styles.statuscode.backgroundColor = "#fbae40";
      styles.statuscode.color = "#253858";
      break;
    case "Partially Degraded Service":
      styles.statuscode.backgroundColor = "#fbae40";
      styles.statuscode.color = "#253858";
      break;
    case "Service Under Maintenance":
      styles.statuscode.backgroundColor = "#0088ff";
      break;
    default:
      styles.statuscode.backgroundColor = "#bbb";
  }

  const options = [
    { value: "kctbh9vrtdwd", label: "GitHub" },
    { value: "3tgl2vf85cht", label: "SendGrid" },
    { value: "bqlf8qjztdtr", label: "BitBucket" },
    { value: "7yh3h3y0c0x1", label: "JIRA" },
    { value: "y2j98763l56x", label: "Atlassian Status Page" },
    { value: "t34htyd6jblf", label: "Dropbox" },
    { value: "s2k7tnzlhrpw", label: "DigitalOcean" },
    { value: "yfj40zdsk34s", label: "Twitch" },
    { value: "2kbc0d48tv3j", label: "Reddit" },
    { value: "zjttvm6ql9lp", label: "Twitter" },
    { value: "yh6f0r4529hb", label: "Cloudflare" },
    { value: "gpkpyklzq55q", label: "Twilio" },
    { value: "kr0djjh0jyy9", label: "Coinbase" },
    { value: "1jkhm1drpysj", label: "Squarespace" },
    { value: "xf8120tyqx8n", label: "MessageBird" },
    { value: "bhk5nysrlnr0", label: "SimpleTexting" },
  ];

  const [selection, setSelection] = useState({
    value: "kctbh9vrtdwd",
    label: "GitHub",
  });

  function handleSelection(selection) {
    setSelection(selection);
    setLoader(!loader);
  }

  function getStatus() {
    const pageid = selection.value;
    if (pageid == "y2j98763l56x") {
      const url = "https://y2j98763l56x.metastatuspage.com/api/v2/summary.json";
      return fetch(url).then((data) => data.json());
    }
    const url = `https://${pageid}.statuspage.io/api/v2/summary.json`;
    return fetch(url).then((data) => data.json());
  }

  useEffect(() => {
    getStatus().then((data) => {
      setComponents(data.components);
      setStatus(data.status);
      setData(data);
      setLoader(!loader);
    });
  }, [selection]);

  return (
    <div className="App">
      <div>
        <header className="App-header">
          <h1 className="title"></h1>
          <div className="selector">
            <Select
              styles={styles}
              name="form-field-name"
              value={selection}
              options={options}
              onChange={(value) => handleSelection(value)}
              defaultValue={{ value: "kctbh9vrtdwd", label: "GitHub" }}
            />
          </div>
        </header>
        <h2>{selection.label}</h2>
        <h3 className="title-desc" style={styles.statuscode}>
          {status.description}
        </h3>
      </div>
      {loader ? (
        <div style={styles.loader}>
          <Loader type="Bars" color="#253858" height={40} width={40} />
        </div>
      ) : (
        <List components={components} />
      )}
    </div>
  );
}

export default App;
